<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'EmptyView',
    template: '<div></div>',
  })
</script>
